import z from 'zod'

export const pricingTierFormSchema = z
  .object({
    tierId: z.number().int().positive().optional(),
    minQuantity: z
      .number()
      .int()
      .min(1, 'La cantidad minima debe ser mayor a cero'),
    profitPercentage: z.number().min(0, 'La utilidad no puede ser negativa'),
    discountPercentage: z
      .number()
      .min(0)
      .max(100, 'El descuento no puede superar 100%'),
    startsAt: z.string().min(1, 'La fecha y hora de inicio es requerida'),
    endsAt: z.string().min(1, 'La fecha y hora de fin es requerida'),
    isActive: z.boolean(),
    lifecycleStatus: z
      .enum(['ACTIVE', 'SCHEDULED', 'EXPIRED', 'INACTIVE'])
      .optional(),
    price: z.string(),
    priceWithTax: z.string(),
  })
  .superRefine((tier, context) => {
    if (!tier.startsAt || !tier.endsAt) return

    if (new Date(tier.endsAt).getTime() <= new Date(tier.startsAt).getTime()) {
      context.addIssue({
        code: 'custom',
        path: ['endsAt'],
        message: 'La fecha y hora de fin debe ser posterior al inicio',
      })
    }
  })

export function emptyPricingTier() {
  return {
    minQuantity: 1,
    profitPercentage: 0,
    discountPercentage: 0,
    startsAt: '',
    endsAt: '',
    isActive: true,
    price: '',
    priceWithTax: '',
  }
}

export function toIsoDateTime(value: string): string {
  return new Date(value).toISOString()
}

export function toDateTimeLocalValue(value?: string | null): string {
  if (!value) return ''

  const date = new Date(value)
  const offset = date.getTimezoneOffset() * 60_000

  return new Date(date.getTime() - offset).toISOString().slice(0, 16)
}

export function resolvePricingTierStatus(
  startsAt: string,
  endsAt: string,
  isActive: boolean,
): 'ACTIVE' | 'SCHEDULED' | 'EXPIRED' | 'INACTIVE' {
  const now = Date.now()
  const start = startsAt ? new Date(startsAt).getTime() : Number.NaN
  const end = endsAt ? new Date(endsAt).getTime() : Number.NaN

  if (Number.isFinite(end) && end <= now) return 'EXPIRED'
  if (!isActive) return 'INACTIVE'
  if (Number.isFinite(start) && start > now) return 'SCHEDULED'
  if (
    Number.isFinite(start) &&
    Number.isFinite(end) &&
    start <= now &&
    end > now
  )
    return 'ACTIVE'

  return 'INACTIVE'
}

export const pricingTierStatusLabels = {
  ACTIVE: 'Activo',
  SCHEDULED: 'Programado',
  EXPIRED: 'Expirado',
  INACTIVE: 'Inactivo',
} as const
